import React from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';

import {
    Flex,
    Spacer,
    Checkbox,
} from '@zillow/constellation';
import { Tag } from '@zillow/zrs-comet';

import propertyUtils from 'app/shared/utils/propertyUtils';
import numberUtils from 'app/shared/utils/numberUtils';
import { getTagTypeByKey, STATUS_KEY } from 'app/shared/utils/statusTagUtils';

import {
    PhotoContainer,
    StyledCityStateText,
    StyledContainer,
    StyledContentContainer,
    StyledDesktopStatusSpacer,
    StyledEmail,
    StyledFeedSource,
    StyledMobileStatusSpacer,
    StyledMobileStatusTag,
    StyledPhone,
    StyledStreetText,
    StyledSourceDetails,
    StyledFlexWithMobileMargin,
} from './StyledComponent';

const { PROPERTY_DETAILS_OVERVIEW } = STATUS_KEY;
const propTypes = {
    listingData: PropTypes.shape({
        listingAlias: PropTypes.string,
        feedName: PropTypes.string,
        address: PropTypes.shape({
            street: PropTypes.string,
            state: PropTypes.string,
            city: PropTypes.string,
            zip: PropTypes.string,
        }),
        photoUrl: PropTypes.string,
        status: PropTypes.string,
        contactEmail: PropTypes.string,
        contactPhone: PropTypes.string,
    }).isRequired,
    highlightPhone: PropTypes.bool,
    highlightEmail: PropTypes.bool,
    isSelectable: PropTypes.bool,
    isSelected: PropTypes.bool,
    onCheckboxClick: PropTypes.func,
};

const defaultProps = {
    highlightEmail: false,
    highlightPhone: false,
    isSelectable: false,
    isSelected: false,
    onCheckboxClick: () => {},
};

const ClaimListingCard = ({
    listingData: {
        address,
        photoUrl,
        feedName,
        status,
        contactEmail,
        contactPhone,
    },
    highlightPhone,
    highlightEmail,
    isSelectable,
    isSelected,
    onCheckboxClick,
}) => {
    const {
        formattedStreet,
        formattedCityStateZip,
    } = propertyUtils.formatAddress(address);
    const formattedPhone = numberUtils.formatPhoneNumberInput(contactPhone);
    const formattedEmail = truncate(contactEmail, { length: 38, omission: '...' });

    return (
        <StyledContainer
            className="ClaimListingCard"
            isSelectable={isSelectable}
            onClick={onCheckboxClick}
        >
            <StyledContentContainer>
                <Flex display="flex" alignItems="center">
                    {isSelectable && (
                        <Spacer paddingRight="sm">
                            <Checkbox checked={isSelected} />
                        </Spacer>
                    )}
                    <PhotoContainer primaryPhotoUrl={photoUrl}>
                        <StyledMobileStatusSpacer paddingLeft="xs" paddingTop="xs">
                            <StyledMobileStatusTag
                                appearance={getTagTypeByKey(PROPERTY_DETAILS_OVERVIEW, status)}
                                size="sm"
                                status={status}
                            >
                                {status}
                            </StyledMobileStatusTag>
                        </StyledMobileStatusSpacer>
                    </PhotoContainer>
                </Flex>
                <StyledFlexWithMobileMargin isSelectable={isSelectable}>
                    <StyledDesktopStatusSpacer marginY="xs">
                        <Tag
                            appearance={getTagTypeByKey(PROPERTY_DETAILS_OVERVIEW, status)}
                            status={status}
                        >
                            {status}
                        </Tag>
                    </StyledDesktopStatusSpacer>
                    <StyledStreetText as="div">{formattedStreet}</StyledStreetText>
                    <StyledCityStateText as="div">
                        {formattedCityStateZip}
                    </StyledCityStateText>
                    <StyledSourceDetails>
                        <StyledFeedSource bold={true}>{feedName}</StyledFeedSource>
                        <StyledEmail bold={highlightEmail}>{formattedEmail}</StyledEmail>
                        <StyledPhone bold={highlightPhone}>{formattedPhone}</StyledPhone>
                    </StyledSourceDetails>
                </StyledFlexWithMobileMargin>
            </StyledContentContainer>
        </StyledContainer>
    );
};

ClaimListingCard.propTypes = propTypes;
ClaimListingCard.defaultProps = defaultProps;

export default ClaimListingCard;
